// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/puzzle.js';

import { paths } from '../generated/puzzle';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('puzzle', Original, paths);
